export default __webpack_public_path__ + "static/media/whatsapp.550fd1c4.svg";